angular
	.module 'App.Module.InventoryCount', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'inventory_count',
				url: '/inventory_counts?stock_location_id'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@inventory_count':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'InventoryCountSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Stock.Stock'
					searchParams:
						attribute: 'id'
						repositoryName: 'InventoryCountRepository'
						title: 'inventory.counts'
						labelTemplate: '@app/inventory-count/inventory-count.search-result-label.html'
				resolve:
					currencies: (CurrencyRepository) ->
						return CurrencyRepository.getEntities()

			.state 'inventory_count.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					inventoryCount: (InventoryCountRepository, $stateParams) ->
						query = InventoryCountRepository.getQuery()
						query.withoutAnyRelations()

						return InventoryCountRepository.getEntity($stateParams.id, query)
					shops: (ShopRepository) ->
						return ShopRepository.getEntities()
					stockLocations: (StockLocationRepository) ->
						return StockLocationRepository.getEntities()

			.state 'inventory_count.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'InventoryCountController'
						controllerAs: 'vm'
						templateUrl: "@app/inventory-count/inventory-count.view.html"
